export const glueEaseOutSoft = 'cubic-bezier(0.6, 0, 0.7, 1)';
export const glueEaseInSoft = 'cubic-bezier(0.3, 0, 0.4, 1)';
export const glueEaseOutHard = 'cubic-bezier(1, 0, 0.7, 1)';
export const glueEaseInHard = 'cubic-bezier(0.3, 0, 0, 1)';
export const glueEaseOutExtreme = 'cubic-bezier(1, 0, 1, 1)';
export const glueEaseInExtreme = 'cubic-bezier(0, 0, 0, 1)';
export const glueEaseInOut = 'cubic-bezier(0.3, 0, 0.7, 1)';
